import React, { useEffect, useState } from "react";
import {
  Button,
  Row,
  Col,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import { GetClassesBySchoolId } from "../../actions/adminQueries";
import CreateStudent from "../Teacher/CreateStudent";
import StudentTable from "../../components/Tables/StudentTable";
import { FormattedMessage } from "react-intl";
import EditStudent from "../../components/Modal/EditStudent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useLocation } from "react-router-dom";

function AdminStudents() {
  const location = useLocation();
  const [filterSearch, setFilterSearch] = useState("");
  const [students, setStudents] = useState([]);
  const [studentEditModal, setStudentEditModal] = useState(false);
  const [school] = useState(
    location.state
      ? location.state.school
      : JSON.parse(localStorage.getItem("school")),
  );
  const [displayCreateStudentModal, setDisplayCreateStudentModal] =
    useState(false);
  const [studentToUpdate, setStudentToUpdate] = useState(null);

  const classesQuery = GetClassesBySchoolId(school.id);

  useEffect(() => {
    localStorage.setItem("school", JSON.stringify(school));
  }, [school]);

  useEffect(() => {
    if (!classesQuery.isPending && classesQuery.data) {
      var tempStudents = [];
      classesQuery.data.forEach((c) => {
        c.students.forEach((s) => {
          tempStudents.push(s);
        });
      });
      setStudents(tempStudents);
    }
  }, [classesQuery.data, classesQuery.isPending]);

  const toggleStudentEditModal = (student) => {
    setStudentToUpdate(null);

    if (student && student.hasOwnProperty("email")) {
      setStudentToUpdate(student);
    }
    setStudentEditModal(!studentEditModal);
  };

  const updateStudents = () => {
    classesQuery.refetch();
  };

  const handleFilterSearch = (event) => {
    setFilterSearch(event.target.value);
  };

  const toggleCreateStudentModal = () => {
    setDisplayCreateStudentModal(!displayCreateStudentModal);
  };

  const updateClassesAndStudents = () => {
    setDisplayCreateStudentModal(false);
    updateStudents();
  };

  return (
    <div>
      <div className="card card-body">
        <h5 className="no-margin">Elever {school.name}</h5>
      </div>
      <div className="container-fluid admin-container">
        <Col>
          <Row className="search-row">
            <Col className="col-3">
              <Input
                placeholder="Sök elever"
                onChange={(data) => handleFilterSearch(data)}
              />
            </Col>
            <Col className="col-9">
              <Button
                color="primary"
                outline
                className="float-end"
                onClick={() => toggleCreateStudentModal()}
              >
                <FontAwesomeIcon icon="plus" />
              </Button>
            </Col>
          </Row>
          <StudentTable
            filter={filterSearch}
            toggleEdit={toggleStudentEditModal}
            showClass={true}
            students={students}
          />
        </Col>
      </div>

      <Modal
        size="lg"
        isOpen={displayCreateStudentModal}
        toggle={toggleCreateStudentModal}
      >
        <ModalHeader toggle={toggleCreateStudentModal}>
          <FormattedMessage id="Views.Teacher.Students.Modal.AddNewStudent" />
        </ModalHeader>
        <ModalBody>
          <CreateStudent
            classes={classesQuery.data || []}
            updateStudents={updateClassesAndStudents}
            dismissModal={toggleCreateStudentModal}
          />
        </ModalBody>
      </Modal>

      <EditStudent
        toggle={toggleStudentEditModal}
        isOpen={studentEditModal}
        student={studentToUpdate}
        updateStudents={updateStudents}
        classes={classesQuery.data || []}
      />
    </div>
  );
}

export default AdminStudents;
